import classNames from 'styles/utils/classNames';

interface Props {
  className?: string;
}

/** The 3D warning triangle (Figma "Big picture / Warning 3D"): textured triangle,
 *  floor shadow and a white exclamation, laid out with the design's insets. */
export default function Warning3dIllustration({ className }: Props) {
  return (
    <div className={classNames('relative', className)} aria-hidden>
      <img
        src="/images/app/warning-3d/shadow.svg"
        alt=""
        className="absolute inset-[78.18%_0_3.49%_0] h-auto w-full"
      />
      <img
        src="/images/app/warning-3d/triangle.png"
        alt=""
        className="absolute inset-[0.83%_13.33%_25.83%_13.33%] h-[73.34%] w-[73.34%] object-cover"
      />
      <div className="absolute inset-[48.33%_46.67%_45%_46.67%] rounded-full bg-white blur-[1.5px]" />
      <div className="absolute bottom-[55.83%] left-[48.33%] right-[47.5%] top-1/4">
        <img
          src="/images/app/warning-3d/bar.svg"
          alt=""
          className="absolute inset-[-13.04%_-57.83%_-13.04%_-60%] h-[126%] w-[218%] max-w-none"
        />
      </div>
    </div>
  );
}
